import { useContext } from "react";
import { context } from "./context";

export const usePluginContext = () => useContext(context);
